/* @sravni/react-design-system version 0.2.60 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { noop, useStyles } from '@sravni/react-utils';
import modules_5f96f03e from '../styles/Switch.module.less.js';

/**
 * @description The Switch component is used to switch between two options and the result of the change is immediate
 *
 * @component
 * @example
 * ```jsx
 * <Switch>content</Switch>
 * ```
 */
var Switch = React.forwardRef(function (props, ref) {
    var name = props.name, value = props.value, checked = props.checked, disabled = props.disabled, readOnly = props.readOnly, className = props.className, children = props.children, _a = props.onChange, onChange = _a === void 0 ? noop : _a, restProps = __rest(props, ["name", "value", "checked", "disabled", "readOnly", "className", "children", "onChange"]);
    var cx = useStyles(modules_5f96f03e);
    var classNames = cx(className, 'container', {
        checked: checked,
        disabled: disabled,
        readOnly: readOnly,
    });
    var controlClassNames = cx('control', {
        checked: checked,
        disabled: disabled,
    });
    var handlerClassNames = cx('handler', {
        checked: checked,
        disabled: disabled,
    });
    // const handleClick = (event)
    return (React.createElement("label", { "data-qa": "Switch", className: classNames },
        React.createElement("input", __assign({ ref: ref, className: cx('input'), type: "checkbox", name: name, value: value, checked: checked, disabled: disabled, onChange: onChange }, restProps)),
        React.createElement("div", { className: controlClassNames },
            React.createElement("div", { className: handlerClassNames })),
        children ? React.createElement("span", { className: cx('label') }, children) : null));
});
Switch.defaultProps = {
    checked: false,
};
Switch.displayName = 'Switch';

export default Switch;
//# sourceMappingURL=Switch.js.map
